export default {"src":"/_next/static/media/trusted-icon.3594043f.svg","height":33,"width":33};